import { Record } from 'immutable';
import { schema } from 'normalizr';

export const WeeklyInternationalPowerMeterReport = new Record({
  id: undefined,
  report_date: undefined,
  consumed_energy: undefined,
  site: undefined,
});

export const weeklyInternationalPowerMeterReportSchema = new schema.Entity('weeklyInternationalPowerMeterReports');

// for reading in nested models, object with { field: schema }
// weeklyInternationalPowerMeterReportSchema.define({  });
